module.exports = __webpack_public_path__ + "static/media/Neue.7250d528.ttf";